import { useCallback, useEffect } from 'react';

import { ProfileFlags, useMyProfile } from '@shared/profile';

import { useProfileUpdate, useProfileUpdateSigning } from '../useProfile';

export enum ProductGrouping {
    CUSTOM = 'custom',
    MULTI_PROFILE = 'multiprofile',
}

interface UseOverviewProductGrouping {
    setProductGrouping: (grouping: string) => void;
}

export function useOverviewProductGrouping(): UseOverviewProductGrouping {
    const { data: profile } = useMyProfile();
    const { mutate: updateProfile } = useProfileUpdate();
    const { resolveSigning } = useProfileUpdateSigning();

    // Profile update operation could require signing, but we don't care in this flow, so we just force resolve
    useEffect(() => resolveSigning(), [resolveSigning]);

    const setProductGrouping = useCallback(
        (grouping: string) => {
            const originalFlags = profile?.flags ?? [];

            if (grouping === ProductGrouping.CUSTOM) {
                updateProfile({
                    flags: [...originalFlags, ProfileFlags.MULTIPLE_PROFILES_DISPLAY_DISABLED],
                });
            }

            if (grouping === ProductGrouping.MULTI_PROFILE) {
                updateProfile({
                    flags: originalFlags.filter(
                        (flag) => flag !== ProfileFlags.MULTIPLE_PROFILES_DISPLAY_DISABLED,
                    ),
                });
            }
        },
        [profile?.flags, updateProfile],
    );

    return {
        setProductGrouping,
    };
}
